import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      nav: {
        smartphones: 'Smartphones',
        laptops: 'Laptops',
        accesorios: 'Accesorios',
        digitel: 'Digitel',
        ofertas: 'Ofertas',
        usados: 'Usados',
        servicio: 'Servicio Técnico',
        sucursales: 'Sucursales',
        catalogo: 'Catálogo',
      },
      hero: {
        badge: 'Agente Autorizado Digitel',
        title1: 'Tecnología',
        title2: 'sin límites',
        sub: '9 sucursales en Venezuela. Smartphones, laptops, accesorios y planes Digitel. Envíos a todo el país.',
        cta_catalog: 'Ver catálogo',
        cta_wa: 'Chatear por WhatsApp',
      },
      trust: {
        sucursales: '9 Sucursales',
        envios: 'Delivery nacional',
        garantia: 'Garantía oficial',
        credito: 'Crédito disponible',
        pagos: 'Múltiples pagos',
        servicio: 'Servicios',
        digitel: 'Agente Digitel',
      },
      catalog: {
        title: 'Catálogo',
        subtitle: 'Encuentra el equipo perfecto',
        filter_sucursal: 'Ver precios en',
        all: 'Todas',
        no_price: 'Consultar precio',
        add_cart: 'Agregar',
        wa_consult: 'Consultar',
        sold_out: 'Agotado',
        new: 'Nuevo',
        offer: 'Oferta',
        used: 'Certificado',
      },
      cart: {
        title: 'Tu selección',
        empty: 'Tu carrito está vacío',
        empty_sub: 'Agrega productos del catálogo',
        checkout_wa: 'Consultar por WhatsApp',
        remove: 'Quitar',
        total: 'Total estimado',
        note: '* Los precios finales se confirman con el vendedor',
      },
      sucursales: {
        title: 'Nuestras',
        subtitle: 'sucursales',
        horario: 'Horario',
        como_llegar: 'Cómo llegar',
        wa_sucursal: 'WhatsApp',
      },
      servicios: {
        title: 'Servicios',
        subtitle: 'técnicos',
        label: 'Servicios',
        diag_gratis: 'Diagnóstico gratis.',
        form_title: 'Solicitar revisión',
        nombre: 'Nombre',
        telefono: 'Teléfono / WhatsApp',
        equipo: 'Equipo / Modelo',
        tipo_servicio: 'Tipo de servicio',
        seleccionar: 'Seleccionar...',
        problema: 'Describe el problema',
        sucursal: 'Sucursal más cercana',
        sel_sucursal: 'Seleccionar sucursal...',
        submit: 'Enviar por WhatsApp',
        items: {
          pantalla: 'Cambio de pantalla',
          bateria: 'Cambio de batería',
          software: 'Actualización de software',
          agua: 'Daño por agua',
          carga: 'Puerto de carga',
          general: 'Diagnóstico general',
        },
      },
      digitel: {
        badge: 'Agente Autorizado',
        title: 'Conecta sin límites',
        sub: 'Activa tu línea, recarga tu saldo o elige el plan prepago o pospago ideal para ti.',
        cta: 'Consultar planes',
        planes: 'Planes Digitel',
      },
      credito: {
        title: 'Crédito disponible',
        sub: 'Lleva tu equipo hoy y págalo cómodamente',
      },
      footer: {
        tagline: 'Tu tienda de tecnología en Venezuela.',
        rights: 'Todos los derechos reservados.',
        links_title: 'Tienda',
        info_title: 'Información',
        payments_title: 'Métodos de pago',
        credit_title: 'Crédito disponible',
        social_title: 'Redes sociales',
        politica: 'Política de garantía',
        envios_info: 'Información de envíos',
        contacto: 'Contacto',
        sucursales: 'Sucursales',
        servicio: 'Servicio Técnico',
        ofertas: 'Ofertas',
        usados: 'Usados Certificados',
      },
      ai: {
        title: 'Asistente Nuovocell',
        placeholder: '¿Tienes alguna pregunta?',
        send: 'Enviar',
        greeting: '¡Hola! Soy el asistente de Nuovocell. ¿En qué te puedo ayudar hoy?',
      },
    },
  },
  en: {
    translation: {
      nav: {
        smartphones: 'Smartphones',
        laptops: 'Laptops',
        accesorios: 'Accessories',
        digitel: 'Digitel',
        ofertas: 'Deals',
        usados: 'Certified Used',
        servicio: 'Tech Service',
        sucursales: 'Locations',
        catalogo: 'Catalog',
      },
      hero: {
        badge: 'Authorized Digitel Agent',
        title1: 'Technology',
        title2: 'without limits',
        sub: '8 locations across Venezuela. Smartphones, laptops, accessories and Digitel plans. Nationwide delivery.',
        cta_catalog: 'Browse catalog',
        cta_wa: 'Chat on WhatsApp',
      },
      trust: {
        sucursales: '8 Locations',
        envios: 'Nationwide delivery',
        garantia: 'Official warranty',
        credito: 'Credit available',
        pagos: 'Multiple payments',
        servicio: 'Services',
        digitel: 'Digitel Agent',
      },
      catalog: {
        title: 'Catalog',
        subtitle: 'Find the perfect device',
        filter_sucursal: 'Show prices at',
        all: 'All',
        no_price: 'Ask for price',
        add_cart: 'Add',
        wa_consult: 'Inquire',
        sold_out: 'Out of stock',
        new: 'New',
        offer: 'Sale',
        used: 'Certified',
      },
      cart: {
        title: 'Your selection',
        empty: 'Your cart is empty',
        empty_sub: 'Add products from the catalog',
        checkout_wa: 'Inquire via WhatsApp',
        remove: 'Remove',
        total: 'Estimated total',
        note: '* Final prices confirmed with the seller',
      },
      sucursales: {
        title: 'Our',
        subtitle: 'locations',
        horario: 'Hours',
        como_llegar: 'Get directions',
        wa_sucursal: 'WhatsApp',
      },
      servicios: {
        title: 'Technical',
        subtitle: 'services',
        label: 'Services',
        diag_gratis: 'Free diagnosis.',
        form_title: 'Request a repair',
        nombre: 'Name',
        telefono: 'Phone / WhatsApp',
        equipo: 'Device / Model',
        tipo_servicio: 'Service type',
        seleccionar: 'Select...',
        problema: 'Describe the issue',
        sucursal: 'Nearest location',
        sel_sucursal: 'Select location...',
        submit: 'Send via WhatsApp',
        items: {
          pantalla: 'Screen replacement',
          bateria: 'Battery replacement',
          software: 'Software update',
          agua: 'Water damage',
          carga: 'Charging port',
          general: 'General diagnosis',
        },
      },
      digitel: {
        badge: 'Authorized Agent',
        title: 'Connect without limits',
        sub: 'Activate your line, recharge your balance or choose the ideal prepaid or postpaid plan.',
        cta: 'Check plans',
        planes: 'Digitel Plans',
      },
      credito: {
        title: 'Credit available',
        sub: 'Take your device today and pay comfortably',
      },
      footer: {
        tagline: 'Your technology store in Venezuela.',
        rights: 'All rights reserved.',
        links_title: 'Store',
        info_title: 'Information',
        payments_title: 'Payment methods',
        credit_title: 'Credit available',
        social_title: 'Social media',
        politica: 'Warranty policy',
        envios_info: 'Shipping info',
        contacto: 'Contact',
        sucursales: 'Locations',
        servicio: 'Tech Service',
        ofertas: 'Deals',
        usados: 'Certified Used',
      },
      ai: {
        title: 'Nuovocell Assistant',
        placeholder: 'Got a question?',
        send: 'Send',
        greeting: "Hi! I'm the Nuovocell assistant. How can I help you today?",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;

